import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const WhatsappIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <circle
      cx="16"
      cy="16"
      fill={preserveColor ? "#27D045" : "transparent"}
      r="12"
    />
    <path
      d="M20.589 11.406a6.421 6.421 0 0 0-4.562-1.882c-3.555 0-6.448 2.879-6.45 6.418a6.38 6.38 0 0 0 .861 3.208l-.915 3.326 3.42-.892c.941.511 2.002.78 3.081.78h.003c3.554 0 6.448-2.878 6.45-6.417 0-1.715-.67-3.328-1.888-4.541Zm-4.562 9.875h-.002a5.374 5.374 0 0 1-2.729-.743l-.195-.116-2.03.53.542-1.97-.127-.201a5.302 5.302 0 0 1-.82-2.84c.002-2.94 2.406-5.333 5.363-5.333 1.432 0 2.778.556 3.79 1.564a5.289 5.289 0 0 1 1.568 3.774c-.001 2.942-2.406 5.335-5.36 5.335Zm2.94-3.995c-.16-.08-.953-.468-1.101-.522-.148-.053-.255-.08-.362.08a10.08 10.08 0 0 1-.51.63c-.095.106-.189.12-.35.04-.16-.081-.68-.25-1.296-.797a4.837 4.837 0 0 1-.896-1.11c-.094-.161-.01-.248.07-.328.073-.072.161-.187.242-.28.08-.094.107-.161.161-.268.054-.107.027-.2-.013-.281-.04-.08-.363-.87-.497-1.19-.13-.313-.264-.271-.362-.276a6.566 6.566 0 0 0-.31-.006.593.593 0 0 0-.43.2c-.147.161-.563.55-.563 1.339 0 .789.577 1.552.658 1.659.08.107 1.136 1.727 2.753 2.422.384.165.684.264.918.337.386.123.738.105 1.015.064.31-.046.954-.388 1.088-.763.134-.374.134-.695.094-.762-.04-.067-.148-.108-.309-.188Z"
      fill={preserveColor ? "#fff" : undefined}
    />
  </BaseIcon>
);
